import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import throttle from 'lodash/throttle';

import Button from 'src/components/Button';
import FontIcon from 'src/components/FontIcon';

import theme from 'src/styles/components/CallWaiterButton.module.scss';
import { ROUTE_TYPES_VALUES } from 'src/modules/Restaurant';

const CallWaiterButton = ({
    className,
    pushNotification,
    isIconButton,
    sendCallWaiter,
    context,
    flat,
    showNotification,
    waiterCalled,
    waiterCallError,
    canCreateOrders,
    sessionError
}) => {
    const intl = useIntl();

    useEffect(() => {
        if (showNotification) {
            waiterCalled();
        }
    }, [showNotification]);

    useEffect(() => {
        if (waiterCallError) {
            pushNotification({
                message: (
                    <div className={theme.notification}>
                        <div className={theme.notificationIcon}>
                            <FontIcon value="icon-call-waiter" />
                        </div>
                        {intl.formatMessage({ id: `Error.${waiterCallError}` })}
                    </div>
                ),
                isDismissButtonEnabled: false
            });
            waiterCalled();
        }
    }, [waiterCallError]);

    const callWaiter = useCallback(throttle(() => {
        sendCallWaiter(context);
    }, 5000), [context]);

    if (!context
        || context.routeType === ROUTE_TYPES_VALUES.BILL_WAIT
        || context.routeType === ROUTE_TYPES_VALUES.MENU
        || context.routeType === ROUTE_TYPES_VALUES.RESTAURANT_CLOSED
        || context.routeType === ROUTE_TYPES_VALUES.AREA_NOT_ACTIVE
        || !canCreateOrders
        || sessionError) {
        return null;
    }

    const buttonProps = isIconButton
        ? {
            icon: 'icon-call-waiter',
            floating: true,
            mini: true
        }
        : {
            raised: true
        };

    return (
        <Button
          className={className}
          onClick={callWaiter}
          flat={flat}
          {...buttonProps}
        >
            {!isIconButton && intl.formatMessage({ id: 'App.callWaiter' })}
        </Button>
    );
};

CallWaiterButton.propTypes = {
    className: PropTypes.string,
    pushNotification: PropTypes.func.isRequired,
    isIconButton: PropTypes.bool,
    icon: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    sendCallWaiter: PropTypes.func.isRequired,
    context: PropTypes.shape({
        restaurantId: PropTypes.string,
        tableId: PropTypes.string,
        routeType: PropTypes.number
    }),
    showNotification: PropTypes.bool.isRequired,
    waiterCalled: PropTypes.func.isRequired,
    waiterCallError: PropTypes.string,
    sessionError: PropTypes.bool.isRequired,
    flat: PropTypes.bool,
    billStatus: PropTypes.number,
    canCreateOrders: PropTypes.bool
};

CallWaiterButton.defaultProps = {
    isIconButton: false,
    flat: false
};

export default CallWaiterButton;
